<div class="s3-file-downloader">
    <button mat-raised-button
            [ngClass]="buttonClass"
            [attr.id]="buttonId ? buttonId : null"
            type="button"
            (click)="downloadFile($event)">
        <span>{{ buttonText | translate }}</span>
        <span *ngIf="showDownloadIcon"
              class="material-symbols-outlined download-icon">download</span>
    </button>
    <upsc-element-blocker *ngIf="isFileDownloading"></upsc-element-blocker>
</div>
